import * as React from 'react';

function renderTickerItem(headline: string, index: number) {
  const itemNumber = index + 1;

  // We add the rendering logic below so that when the text is too long on the horizontal ads,
  // then we will make the text proportionally smaller, by applying an inline style.
  const tooMuchTextLim = 40;
  const textLim = 50;
  const length = headline.length;
  const percentOfFontDecrease = (length - tooMuchTextLim) / (textLim - tooMuchTextLim);
  const fixTextOverflow = length > tooMuchTextLim;

  let newFontSize;
  let Addtionalclass = "";

  if (window.innerHeight <= 50) {
    newFontSize = 15 - (window.innerWidth <= 300 ? 4 : 3) * percentOfFontDecrease;
  } else if (window.innerHeight <= 90) {
    newFontSize = 25 - 6 * percentOfFontDecrease;
  } else {
    newFontSize = 35 - 6 * percentOfFontDecrease;
  }

  if (length > 34 && length < 40) {
    Addtionalclass = "shrunk-one"
  }
  else if (length > 39 && length < 45) {
    Addtionalclass = "shrunk-two"
  }
  else if (length > 44) {
    Addtionalclass = "shrunk-three"
  }

  const smallFontStyle: React.CSSProperties = {
    fontSize: `${newFontSize}px`,
  };

  return (
    <div
      key={itemNumber}
      className={`ticker-item ticker-item-${itemNumber} ${Addtionalclass}`}
    >
      <span
        dangerouslySetInnerHTML={{ __html: headline }}
      />
    </div>
  );
}

export interface TickerProps {
  headlines: string[];
}

const Ticker = (props: TickerProps) => {
  return <div className="ticker">{props.headlines.map(renderTickerItem)}</div>;
};

export default Ticker;
